export const VerificationStatus = {
  Verified: 'Verified',
  NotVerified: 'Not Verified',
  InProgress: 'In Progress',
  DocumentNoMatch: 'Document No Match',
  IdentityNoMatch: 'Identity No Match',
  Rejected: 'Rejected',
};

export default {
  VerificationStatus,
};
